import React from 'react';
import optimizedAssets from '../../data/optimizedAssets.json';

const getAssetMetadata = (src) => {
  if (typeof src !== 'string' || !src.startsWith('/assets/')) return null;
  try {
    const sourcePath = decodeURIComponent(src.split(/[?#]/, 1)[0]);
    return optimizedAssets[sourcePath] || null;
  } catch {
    return null;
  }
};

const toSrcSet = (sources = []) => sources.map(({ src, width }) => `${src} ${width}w`).join(', ');

const OptimizedImage = ({ src, alt = '', sizes = '100vw', loading = 'lazy', decoding = 'async', ...imageProps }) => {
  const metadata = getAssetMetadata(src);
  if (!metadata) {
    return <img src={src} alt={alt} sizes={sizes} loading={loading} decoding={decoding} {...imageProps} />;
  }

  return (
    <picture style={{ display: 'contents' }}>
      {metadata.avif.length > 0 && (
        <source type="image/avif" srcSet={toSrcSet(metadata.avif)} sizes={sizes} />
      )}
      <source type="image/webp" srcSet={toSrcSet(metadata.webp)} sizes={sizes} />
      <img
        src={src}
        alt={alt}
        width={metadata.width}
        height={metadata.height}
        sizes={sizes}
        loading={loading}
        decoding={decoding}
        {...imageProps}
      />
    </picture>
  );
};

export default OptimizedImage;
